import { render, staticRenderFns } from "./RatingSettings.vue?vue&type=template&id=4951cd92&scoped=true"
import script from "./RatingSettings.vue?vue&type=script&lang=js"
export * from "./RatingSettings.vue?vue&type=script&lang=js"
import style0 from "./RatingSettings.vue?vue&type=style&index=0&id=4951cd92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951cd92",
  null
  
)

export default component.exports